import { createServerFn } from "@tanstack/react-start";

import type { ClientInfos } from "@onesolution/constants";
import { NAVIGATION_COLUMNS } from "@onesolution/constants/monday/navigation";
import { authMiddleware, mondayBoards } from "@onesolution/middlewares";
import type { MONDAY_TYPES } from "@onesolution/monday";
import { mondayClient } from "@onesolution/monday/monday";
import { CACHE_KEYS, cache } from "@onesolution/utils";
import { wrapWithUseQuery } from ".";

const handler = createServerFn()
	.middleware([authMiddleware, mondayBoards])
	.handler(async ({ context }) => {
		return cache.getOrSet<ClientInfos>(
			`${CACHE_KEYS.clientInfos}-${context.user.monday_workspace_id}`,
			async () => {
				const rawClientInfos = await mondayClient.query.clientInfos(context);
				const rawNavigationInfos = await mondayClient.query.itemPageByValues<{
					active: MONDAY_TYPES["checkbox"];
					name: MONDAY_TYPES["text"];
					iconName: MONDAY_TYPES["text"];
					url: MONDAY_TYPES["text"];
				}>({
					boardId: context.boards.navigation,
					columnIds: [
						NAVIGATION_COLUMNS.active,
						NAVIGATION_COLUMNS.name,
						NAVIGATION_COLUMNS.iconName,
						NAVIGATION_COLUMNS.url,
					],
					filter: [],
				});

				return {
					logo: rawClientInfos.assets[0]?.public_url,
					boxRootFolderId: rawClientInfos.boxFolderId,
					disabledFeatures: rawClientInfos.featureFlag.map((f) => f.label),
					boxGroupId: rawClientInfos.boxUserGroupId,
					customNavigation: rawNavigationInfos.items.filter(
						(item) => item.active && item.url && item.name && item.iconName,
					),
				};
			},
		);
	});

export const getClientInfosFromServer = wrapWithUseQuery(
	"clientInfos",
	handler,
);
